var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMathleticsMLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00ABE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6334 7.80516C22.1704 7.80516 21.9753 8.08279 21.8436 8.35867L16.0252 21.3674L10.2039 8.35423C10.0745 8.08279 9.87935 7.80516 9.41638 7.80516C9.19405 7.79734 8.97857 7.88634 8.82127 8.05096C8.66396 8.21557 8.57892 8.44107 8.58639 8.67374V23.1063C8.58639 23.5795 8.9529 23.963 9.40501 23.963C9.85712 23.963 10.2236 23.5795 10.2236 23.1063V12.202L15.2336 23.4425C15.3745 23.7665 15.6832 23.9746 16.0234 23.975C16.3636 23.9754 16.6727 23.768 16.8143 23.4443L21.825 12.202V23.1063C21.825 23.5795 22.1915 23.963 22.6436 23.963C23.0957 23.963 23.4622 23.5795 23.4622 23.1063V8.67374C23.4696 8.4413 23.3848 8.21601 23.2277 8.05143C23.0707 7.88686 22.8555 7.7977 22.6334 7.80516Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathleticsMLogo);
export default __webpack_public_path__ + "static/media/MathleticsMLogo.4baff5baaf84c987769d9776ea510fe5.svg";
export { ForwardRef as ReactComponent };